module.exports = __webpack_public_path__ + "img/accept-b&w.cb026cf4.svg";